import { createAction } from '@mendeley-internal/lib-js-redux-actions';
import api from '../services/api/request';

const APPNAME = 'WebCatalog';

export const trackEvent = createAction(
  'TRACK_EVENT',
  (trackObject) => {
    const {
      context,
      action,
      value,
      label,
      version,
      profile_uuid = null // eslint-disable-line camelcase
    } = trackObject;

    const name = `${APPNAME}${context}${action}`;
    const properties = { ...value, label };

    return api.post('events', {
      profile_uuid, name, properties, version
    });
  }
);

export const trackPageView = createAction(
  'TRACK_PAGE_VIEW',
  (page, pageName, properties) => api.post('events', {
    name: `${APPNAME}${pageName}`,
    properties,
  })
);



// WEBPACK FOOTER //
// ./src/universal/ui/actions/tracking.js